/* ajaxed-atc.js — compatibility fallback to avoid hijacking Kaching Bundles and UpCart */
(() => {
  const hasUpcart = () => Boolean(
    window.Upcart ||
    document.getElementById('UpcartPopupBackDrop') ||
    document.querySelector('[data-upcart-cart-button]') ||
    document.querySelector('[href*="upcart"]')
  );

  const isKachingManagedForm = (form) => Boolean(
    form?.querySelector('[name="properties[__kaching_bundles]"]') ||
    form?.querySelector('input[name*="__kaching_bundles"]') ||
    form?.closest('kaching-bundles-block') ||
    document.querySelector('kaching-bundles-block')
  );

  const shouldBypassCustomAjax = (form) => hasUpcart() || isKachingManagedForm(form);

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;

    if (shouldBypassCustomAjax(form)) {
      return;
    }
  }, true);
})();
